import { LineSegments, Parallelogram, Polygon } from '@phosphor-icons/react';
import { semanticColors } from '@vake/ui-kit';

export const verifiedLabel = 'Verified Vessel';
export const verifiedVesselIcon = (
    <div className="bg-success-default rounded-full w-2 h-2 border-1 border-success-background" />
);

export const darkLabel = 'Dark Vessel';
export const darkVesselIcon = (
    <div className="bg-danger-default rounded-full w-2 h-2 border-1 border-danger-background" />
);

export const notAbleToVerifyLabel = 'Unverified Vessel';
export const notAbleToVerifyVesselIcon = (
    <div className="bg-primary-action-button rounded-full w-2 h-2 border-1 border-primary-action-background" />
);

export const windmillIcon = <div className="bg-cyan-default rounded-full w-2 h-2 border-1 border-cyan-600" />;

export const platformIcon = <div className="bg-mint-default rounded-full w-2 h-2 border-1 border-mint-600" />;

export const legendData = [
    {
        title: 'Map Icons',
        items: [
            {
                label: verifiedLabel,
                icon: verifiedVesselIcon,
                // tooltip: 'Explain',
            },
            {
                label: darkLabel,
                icon: darkVesselIcon,
                // tooltip: 'Explain',
            },
            {
                label: notAbleToVerifyLabel,
                icon: notAbleToVerifyVesselIcon,
                // tooltip: 'Explain',
            },
            {
                label: 'Windmill',
                icon: windmillIcon,
                // tooltip: 'Explain',
            },
            {
                label: 'Platform',
                icon: platformIcon,
                // tooltip: 'Explain',
            },
        ],
    },
    {
        title: 'Satellite Passes Indicators',
        items: [
            {
                label: 'Captured Satellite Passes',
                icon: <Parallelogram size={16} weight="fill" color={semanticColors['primary-action'].graphical} />,
                // tooltip: 'Explain',
            },
            {
                label: 'Incoming Satellite Passes',
                icon: <Parallelogram size={16} weight="fill" color={semanticColors['system-fill'].secondary} />,
                // tooltip: 'Explain',
            },
        ],
    },
    {
        title: 'Satellite Processing Statuses',
        items: [
            {
                label: 'Successfully Processed',
                icon: <Parallelogram size={16} weight="fill" color={semanticColors.success.default} />,
                // tooltip: 'Explain',
            },
            {
                label: 'Currently Being Processed',
                icon: <Parallelogram size={16} weight="fill" color={semanticColors.warning.default} />,
                // tooltip: 'Explain',
            },
            {
                label: 'In Processing Queue',
                icon: <Parallelogram size={16} weight="fill" color={semanticColors.warning.background} />,
                // tooltip: 'Explain',
            },
            {
                label: 'Processing Failed',
                icon: <Parallelogram size={16} weight="fill" color={semanticColors.danger.background} />,
                // tooltip: 'Explain',
            },
        ],
    },
    {
        title: 'Miscellaneous',
        items: [
            {
                label: 'Subscription Area',
                icon: <Polygon size={16} weight="fill" color={semanticColors['primary-action'].button} />,
                // tooltip: 'Explain',
            },
            {
                label: 'Exclusive Economic Zone Borders',
                icon: <LineSegments size={16} weight="fill" color={semanticColors['primary-action']['background-2']} />,
                // tooltip: 'Explain',
            },
        ],
    },
];
